var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_8923)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-652 -108)",
    fill: "#F8F8F6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_194_8923)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -262,
    y: -9,
    width: 306,
    height: 206,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#4B69B2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#4B69B2",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2567 17.3532C24.2586 17.6446 24.1701 17.9294 24.0035 18.1684C23.8368 18.4074 23.6002 18.5889 23.3262 18.6879L18.6891 20.3963L16.9807 25.0334C16.8801 25.3064 16.6982 25.542 16.4595 25.7084C16.2208 25.8748 15.9369 25.964 15.646 25.964C15.355 25.964 15.0711 25.8748 14.8324 25.7084C14.5937 25.542 14.4118 25.3064 14.3112 25.0334L12.6028 20.3963L7.96575 18.6879C7.69275 18.5873 7.45717 18.4054 7.29077 18.1668C7.12437 17.9281 7.03516 17.6442 7.03516 17.3532C7.03516 17.0623 7.12437 16.7783 7.29077 16.5397C7.45717 16.301 7.69275 16.1191 7.96575 16.0185L12.6028 14.3101L14.3112 9.67301C14.4118 9.40001 14.5937 9.16443 14.8324 8.99803C15.0711 8.83163 15.355 8.74242 15.646 8.74242C15.9369 8.74242 16.2208 8.83163 16.4595 8.99803C16.6982 9.16443 16.8801 9.40001 16.9807 9.67301L18.6891 14.3101L23.3262 16.0185C23.6002 16.1175 23.8368 16.299 24.0035 16.538C24.1701 16.777 24.2586 17.0618 24.2567 17.3532V17.3532ZM19.202 8.81873H20.6244V10.2411C20.6244 10.4298 20.6993 10.6107 20.8327 10.744C20.9661 10.8774 21.147 10.9524 21.3356 10.9524C21.5242 10.9524 21.7051 10.8774 21.8385 10.744C21.9719 10.6107 22.0468 10.4298 22.0468 10.2411V8.81873H23.4692C23.6579 8.81873 23.8388 8.7438 23.9721 8.61042C24.1055 8.47704 24.1804 8.29615 24.1804 8.10752C24.1804 7.9189 24.1055 7.738 23.9721 7.60462C23.8388 7.47125 23.6579 7.39632 23.4692 7.39632H22.0468V5.9739C22.0468 5.78528 21.9719 5.60438 21.8385 5.471C21.7051 5.33763 21.5242 5.2627 21.3356 5.2627C21.147 5.2627 20.9661 5.33763 20.8327 5.471C20.6993 5.60438 20.6244 5.78528 20.6244 5.9739V7.39632H19.202C19.0134 7.39632 18.8325 7.47125 18.6991 7.60462C18.5657 7.738 18.4908 7.9189 18.4908 8.10752C18.4908 8.29615 18.5657 8.47704 18.6991 8.61042C18.8325 8.7438 19.0134 8.81873 19.202 8.81873ZM27.0253 11.6636H26.3141V10.9524C26.3141 10.7637 26.2391 10.5828 26.1057 10.4495C25.9724 10.3161 25.7915 10.2411 25.6028 10.2411C25.4142 10.2411 25.2333 10.3161 25.0999 10.4495C24.9666 10.5828 24.8916 10.7637 24.8916 10.9524V11.6636H24.1804C23.9918 11.6636 23.8109 11.7385 23.6775 11.8719C23.5442 12.0052 23.4692 12.1861 23.4692 12.3748C23.4692 12.5634 23.5442 12.7443 23.6775 12.8777C23.8109 13.011 23.9918 13.086 24.1804 13.086H24.8916V13.7972C24.8916 13.9858 24.9666 14.1667 25.0999 14.3001C25.2333 14.4335 25.4142 14.5084 25.6028 14.5084C25.7915 14.5084 25.9724 14.4335 26.1057 14.3001C26.2391 14.1667 26.3141 13.9858 26.3141 13.7972V13.086H27.0253C27.2139 13.086 27.3948 13.011 27.5282 12.8777C27.6615 12.7443 27.7365 12.5634 27.7365 12.3748C27.7365 12.1861 27.6615 12.0052 27.5282 11.8719C27.3948 11.7385 27.2139 11.6636 27.0253 11.6636Z",
    fill: "#F8F8F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_194_8923",
    x: -270,
    y: -15,
    width: 322,
    height: 222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.075 0 0 0 0 0.075 0 0 0 0 0.075 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_194_8923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_194_8923",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_8923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-652 -108)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.809c4a4b76b80bd03b5aa4cb4c3f114d.svg";
export { ForwardRef as ReactComponent };